import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors } from '@vds-core/theme';
/*
fontWeightStrong represents the font weight found in 
typography used when the component is bolded. fontWeightNormal represents the font weight found in 
typography used when the component is not bolded. Font weight is
not exported by typography configs due to the fact that 
typography components may have multiple font weight options
*/

var fontWeightStrong = 700;
var fontWeightNormal = 400;
var WrapperProps = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  //1.0
  padding: PropTypes.string,
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabledState: PropTypes.bool,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  forceFocus: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colorConfig: PropTypes.object
};
var WrapperDefaultProps = {
  checked: false,
  disabled: false,
  disabledState: false,
  borderColor: colors.coolGray3,
  backgroundColor: 'transparent',
  colorConfig: colors,
  forceFocus: false,
  height: undefined
};

var findWidth = function findWidth(width) {
  if (typeof width === 'string') return width;
  return calculateRem(width);
};

var findHeight = function findHeight(height) {
  if (typeof height === 'string') return height;
  return calculateRem(height);
};

var RadioBoxLabelWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "RadioBoxLabelWrapper",
  componentId: "sc-6gb90f-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  border-bottom: ", ";\n  border-left: ", ";\n  border-right: ", ";\n  border-top: ", ";\n  display: block;\n  flex: 1;\n  font-size: ", ";\n  height: ", ";\n  min-height: ", ";\n  position: relative;\n  width: ", ";\n  max-width: 100%;\n  box-sizing: border-box;\n  background-color: ", ";\n  color: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var colorConfig = _ref.colorConfig,
      checked = _ref.checked,
      disabled = _ref.disabled,
      borderColor = _ref.borderColor,
      disabledState = _ref.disabledState;
  return "1px solid ".concat(checked && !disabled ? colorConfig.black : disabledState && disabled ? colorConfig.coolGray3 : borderColor);
}, function (_ref2) {
  var colorConfig = _ref2.colorConfig,
      checked = _ref2.checked,
      disabled = _ref2.disabled,
      borderColor = _ref2.borderColor,
      disabledState = _ref2.disabledState;
  return "1px solid ".concat(checked && !disabled ? colorConfig.black : disabledState && disabled ? colorConfig.coolGray3 : borderColor);
}, function (_ref3) {
  var colorConfig = _ref3.colorConfig,
      checked = _ref3.checked,
      disabled = _ref3.disabled,
      borderColor = _ref3.borderColor,
      disabledState = _ref3.disabledState;
  return "1px solid ".concat(checked && !disabled ? colorConfig.black : disabledState && disabled ? colorConfig.coolGray3 : borderColor);
}, function (_ref4) {
  var colorConfig = _ref4.colorConfig,
      checked = _ref4.checked,
      disabled = _ref4.disabled,
      borderColor = _ref4.borderColor,
      disabledState = _ref4.disabledState;
  return "1px solid ".concat(checked && !disabled ? colorConfig.red : disabledState && disabled ? colorConfig.coolGray3 : borderColor);
}, calculateRem(12), function (_ref5) {
  var height = _ref5.height,
      orientation = _ref5.orientation;
  return height && orientation === 'vertical' ? findHeight(height) : '100%';
}, function (_ref6) {
  var minHeight = _ref6.minHeight;
  return minHeight ? minHeight : calculateRem(49);
}, function (props) {
  return props.width ? findWidth(props.width) : '100%';
}, function (_ref7) {
  var backgroundColor = _ref7.backgroundColor,
      colorConfig = _ref7.colorConfig;
  return backgroundColor;
}, function (_ref8) {
  var disabledState = _ref8.disabledState,
      disabled = _ref8.disabled,
      colorConfig = _ref8.colorConfig;
  return disabledState && disabled ? colorConfig.coolGray3 : colorConfig.black;
}, function (_ref9) {
  var focused = _ref9.focused,
      clicked = _ref9.clicked,
      focusState = _ref9.focusState;
  return focused && !clicked && !focusState && "\n    &:not(:hover) {\n      outline: -webkit-focus-ring-color auto 5px;\n    }\n  ";
}, function (_ref10) {
  var disabled = _ref10.disabled,
      colorConfig = _ref10.colorConfig,
      checked = _ref10.checked,
      orientation = _ref10.orientation;
  return !disabled && "\n    &::before {\n      background:  ".concat(checked ? colorConfig.red : 'none', ";\n      box-shadow: 'none';\n      content: '';\n      height: ").concat(orientation && orientation === 'vertical' ? '100%' : calculateRem(3), ";\n      left: 0px;\n      position: absolute;\n      top: 0;\n      width: ").concat(orientation && orientation === 'vertical' ? calculateRem(3) : '100%', ";\n      z-index: 1;\n    }\n  ");
}, function (_ref11) {
  var disabled = _ref11.disabled,
      colorConfig = _ref11.colorConfig,
      checked = _ref11.checked,
      orientation = _ref11.orientation,
      borderColor = _ref11.borderColor;
  return orientation && orientation === 'vertical' && "\n    border-left: 1px solid ".concat(checked && !disabled ? colorConfig.red : disabled ? colorConfig.coolGray3 : borderColor, ";\n    border-top: 1px solid ").concat(checked && !disabled ? colorConfig.black : disabled ? colorConfig.coolGray3 : borderColor, ";\n   ");
}, function (_ref12) {
  var focused = _ref12.focused,
      clicked = _ref12.clicked,
      focusState = _ref12.focusState,
      disabled = _ref12.disabled,
      colorConfig = _ref12.colorConfig,
      outOfStock = _ref12.outOfStock,
      forceFocus = _ref12.forceFocus;
  return focused && (!clicked || forceFocus) && focusState && !outOfStock && "\n      outline: none;\n      &:not(:hover) {\n         &:after {\n           content: '';\n           position: absolute;\n           left: -4px;\n           top: -4px;\n           right: -4px;\n           bottom: -4px;\n           border: 1px dashed ".concat(colorConfig.black, ";\n         }\n      }\n  ");
}, function (_ref13) {
  var activeState = _ref13.activeState,
      disabled = _ref13.disabled,
      colorConfig = _ref13.colorConfig,
      checked = _ref13.checked,
      active = _ref13.active;
  return activeState && !disabled && !checked && active && "\n       border: 1px solid ".concat(colorConfig.black, ";\n       outline: 1px solid ").concat(colorConfig.black, ";\n     ");
}, function (_ref14) {
  var hoverState = _ref14.hoverState,
      disabled = _ref14.disabled,
      colorConfig = _ref14.colorConfig,
      checked = _ref14.checked,
      active = _ref14.active,
      hovered = _ref14.hovered;
  return hoverState && !disabled && !checked && !active && hovered && "\n     &:hover {\n       border: 1px solid ".concat(colorConfig.coolGray6, ";\n       outline: 1px solid ").concat(colorConfig.coolGray6, ";\n     }\n     ");
});
var LabelBase = /*#__PURE__*/styled.label.withConfig({
  displayName: "LabelBase",
  componentId: "sc-6gb90f-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: ", ";\n  text-decoration: ", ";\n  height: 100%;\n  z-index: 1;\n\n  &:active,\n  &:hover {\n    outline: 0;\n  }\n"])), function (_ref15) {
  var disabled = _ref15.disabled;
  return disabled ? 'normal' : 'pointer';
}, function (_ref16) {
  var disabled = _ref16.disabled,
      disabledState = _ref16.disabledState,
      outOfStock = _ref16.outOfStock;
  return disabled && !disabledState ? 'line-through' : '';
});
var sharedLabelStyles = /*#__PURE__*/css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: block;\n  padding: ", ";\n\n  .LabelContent {\n    display: block;\n    text-decoration: ", ";\n  }\n"])), function (_ref17) {
  var padding = _ref17.padding;
  return padding ? padding : calculateRem(10);
}, function (_ref18) {
  var disabled = _ref18.disabled,
      disabledState = _ref18.disabledState;
  return disabled && !disabledState ? 'line-through' : '';
});
var RadioBoxLabel = /*#__PURE__*/styled(LabelBase).withConfig({
  displayName: "RadioBoxLabel",
  componentId: "sc-6gb90f-2"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-family: ", ";\n"])), sharedLabelStyles, function (_ref19) {
  var textConfig = _ref19.textConfig;
  return textConfig && textConfig.fontSize && calculateRem(textConfig.fontSize);
}, function (_ref20) {
  var textConfig = _ref20.textConfig;
  return textConfig && textConfig.lineHeight && calculateRem(textConfig.lineHeight);
}, function (_ref21) {
  var textConfig = _ref21.textConfig;
  return textConfig && textConfig.fontFamily;
});
var StackedLabel = /*#__PURE__*/styled(LabelBase).withConfig({
  displayName: "StackedLabel",
  componentId: "sc-6gb90f-3"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  flex-grow: 1;\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-family: ", ";\n\n  ", ";\n"])), sharedLabelStyles, fontWeightStrong, function (_ref22) {
  var textConfig = _ref22.textConfig;
  return textConfig && textConfig.fontSize && calculateRem(textConfig.fontSize);
}, function (_ref23) {
  var textConfig = _ref23.textConfig;
  return textConfig && textConfig.lineHeight && calculateRem(textConfig.lineHeight);
}, function (_ref24) {
  var textConfig = _ref24.textConfig;
  return textConfig && textConfig.fontFamily;
}, function (_ref25) {
  var labelMargin = _ref25.labelMargin;
  return labelMargin && "\n    > * {\n      &:not(:last-child) {\n        margin-bottom: ".concat(calculateRem(2), ";\n      }\n    }\n  ");
});
var SubLabel = /*#__PURE__*/styled.span.withConfig({
  displayName: "SubLabel",
  componentId: "sc-6gb90f-4"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: block;\n  font-size: ", ";\n  line-height: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  margin: 0;\n  pointer-events: none;\n"])), function (_ref26) {
  var subtextConfig = _ref26.subtextConfig;
  return subtextConfig && subtextConfig.fontSize && calculateRem(subtextConfig.fontSize);
}, function (_ref27) {
  var subtextConfig = _ref27.subtextConfig;
  return subtextConfig && subtextConfig.lineHeight && calculateRem(subtextConfig.lineHeight);
}, function (_ref28) {
  var subtextConfig = _ref28.subtextConfig;
  return subtextConfig && subtextConfig.fontFamily;
}, fontWeightNormal);
RadioBoxLabelWrapper.propTypes = WrapperProps;
RadioBoxLabelWrapper.defaultProps = WrapperDefaultProps;
export { RadioBoxLabelWrapper, RadioBoxLabel, SubLabel, StackedLabel };